module.exports = __webpack_public_path__ + "images/iret-f37116ec8d886cd84975ea8e7352f823.jpg";